import classNames from 'classnames'
import React, { ReactNode } from 'react'

export type CheckInputAttributes = Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'type' | 'checked' | 'defaultChecked' | 'value' | 'onChange' | 'disabled' | 'aria-invalid'
>

export interface CheckboxProps {
    id: string
    label: ReactNode
    value: string
    checked?: boolean
    className?: string
    input?: CheckInputAttributes
    isDisabled?: boolean
    isInvalid?: boolean
    hiddenDescription?: JSX.Element
    onChange?: (checked: boolean) => void
}

export const Checkbox = (props: CheckboxProps): JSX.Element => {
    const { input, checked, value, isDisabled, isInvalid, id } = props

    const className: string = classNames(
        'checkbox',
        isDisabled && 'is-disabled',
        isInvalid && 'is-invalid',
        props.className,
    )

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const nextValue = event.currentTarget.checked

        if (isDisabled) {
            return
        }

        if (props.onChange) {
            props.onChange(nextValue)
        }
    }

    return (
        <div className={className}>
            <input
                {...input}
                type="checkbox"
                checked={checked}
                disabled={isDisabled}
                value={value}
                onChange={onChange}
                id={id}
                className="checkbox__input"
                aria-invalid={isInvalid}
            />
            <label htmlFor={id} className="checkbox__label">
                {props.label}
            </label>
            <div className="checkbox__inner">
                <span className="checkbox__indicator" />
            </div>
            {props.hiddenDescription && checked && (
                <div className="checkbox__hidden-description">{props.hiddenDescription}</div>
            )}
        </div>
    )
}
